// from https://github.com/NerdWallet/query0/blob/master/src/schema/marketplace/constants.js#L34
export var MARKETPLACE_INSTITUTION_AGGREGATOR_TYPES = {
  PLAID: 'plaid',
  YODLEE: 'yodlee'
}; // from https://github.com/NerdWallet/query0/blob/418cef7ed76e79c0ec371d4fddb9f033288eb2fa/src/schema/financialData/constants.js#L15-L25

export var FINANCIAL_PORTAL_PRIMARY_SOURCES = {
  NERDWALLET: 'NERDWALLET',
  PLAID: 'PLAID',
  QA: 'QA',
  USER: 'USER',
  YODLEE: 'YODLEE'
};